import request from "@/utils/request";
import { patchAxiosConfig } from "@/utils/request";

export function me() {
  return request.get("/customers/me?loyalty", { data: null });
}

export function get(id) {
  return request.get(`/customers/${id}?loyalty`, { data: null });
}

export function all() {
  return request.get("/customers?loyalty", { data: null });
}

export function update(id, data) {
  return request.put(`/customers/${id}?loyalty`, { ...data });
}

export function updateMe(data) {
  return request.put("/customers/me?loyalty", { ...data });
}

export function confirm(token) {
  return request.patch(
    `/account-verification-requests/${token}`,
    { token },
    { ...patchAxiosConfig }
  );
}

export function register(data) {
  return request.post("/customers?loyalty", { ...data });
}

export function updateSettings(data) {
  return request.put("/customers/me/settings?loyalty", { ...data });
}

export function sendConfirm(data) {
  return request.post("/account-verification-requests", { ...data });
}

export function levels(customerId) {
  return request.get(`/card-levels?loyalty`, {
    data: null,
  });
}
